import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { RANGE } from '@/const/constants';

dayjs.extend(utc);

function normalize(from, to) {
  return {
    from: from ? from.startOf('day').toDate() : null,
    to: to ? to.endOf('day').toDate() : null,
  };
}

export function fromArray(range) {
  return normalize(
    range[0] ? dayjs(range[0]) : null,
    range[0] ? dayjs(range[1]) : null,
  );
}

export function getRange(range, minDate = null) {
  const today = dayjs();

  switch (range) {
    case RANGE.ALL_TIME: return normalize(null, today);
    case RANGE.LAST_YEAR: return normalize(
      today.subtract(1, 'year').startOf('year'),
      today.subtract(1, 'year').endOf('year'),
    );
    case RANGE.THIS_YEAR: return normalize(
      today.startOf('year'),
      today,
    );
    case RANGE.LAST_365_DAYS: return normalize(today.subtract(364, 'days'), today);
    case RANGE.LAST_30_DAYS:
      return normalize(today.subtract(29, 'days'), today);
    case RANGE.LAST_7_DAYS: return normalize(today.subtract(6, 'days'), today);
    case RANGE.LAST_3_MONTH: return normalize(
      today.subtract(3, 'month'),
      today,
    );
    case RANGE.LAST_2_MONTHS:
      return normalize(
        today.subtract(2, 'month').startOf('month'),
        today.subtract(1, 'month').endOf('month'),
      );
    case RANGE.LAST_3_MONTHS:
      return normalize(
        today.subtract(3, 'month').startOf('month'),
        today.subtract(1, 'month').endOf('month'),
      );
    case RANGE.LAST_6_MONTHS:
      return normalize(
        today.subtract(6, 'month').startOf('month'),
        today.subtract(1, 'month').endOf('month'),
      );
    case RANGE.LAST_MONTH: return normalize(
      today.subtract(1, 'month').startOf('month'),
      today.subtract(1, 'month').endOf('month'),
    );
    case RANGE.THIS_MONTH: return normalize(
      today.subtract(0, 'month').startOf('month'),
      today.subtract(0, 'month').endOf('month'),
    );
    case RANGE.LAST_WEEK: return normalize(
      today.subtract(1, 'week').startOf('week'),
      today.subtract(1, 'week').endOf('week'),
    );
    case RANGE.YESTERDAY: return normalize(
      today.subtract(1, 'day'),
      today.subtract(1, 'day'),
    );
    case RANGE.TODAY: return normalize(today, today);
    case RANGE.CUSTOM: return normalize(today.subtract(30, 'days'), today);
    case RANGE.CONTRACTOR_TIME: return normalize(dayjs(minDate).add(1, 'day'), today);
    default: throw new Error('Invalid Range Value');
  }
}
